interface Props {
  children: React.ReactNode;
}

export const CounterContainer: React.FC<Props> = ({ children }) => {
  return (
    <div className="grid md:gap-4 lg:gap-5 gap-3 lg:grid-cols-12 md:grid-cols-6 grid-cols-3 items-stretch w-full">
      {children}
    </div>
  );
};
